import { CMSAsset } from "./cmsAsset";

export class CMSEPGEvent {
  epgEventId: number;
  externalId: string;
  channelId: string;
  assetId: string;
  asset: CMSAsset;
  type: string;
  startActual: string;
  endActual: string;
  startScheduled: string;
  endScheduled: string;
  timeshift: boolean;
  catchup: boolean;
  startover: boolean;
  createdAt: string;
  updatedAt: string;

  constructor() {}

  getProgramTitle() {
    return this.asset?.originalTitle;
  }

  getImage() {
    return this.asset?.images?.[0]?.url || "";
  }

  serialize() {
    return {
      epgEventId: this.epgEventId,
      externalId: this.externalId,
      channelId: this.channelId,
      assetId: this.assetId,
      asset: this.asset.serialize(),
      type: this.type,
      startActual: this.startActual,
      endActual: this.endActual,
      startScheduled: this.startScheduled,
      endScheduled: this.endScheduled,
      timeshift: this.timeshift,
      catchup: this.catchup,
      startover: this.startover,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
    };
  }
}
